import Request from "../../shared/utils/_request";

class Position {
  constructor() {}
  //客户管理列表接口
  getList(payload) {
    return Request.post("head-post/job/get-list", payload);
  }
  //获取详情
  getDetail(payload) {
    return Request.post("job/detail", payload);
  }

  getSuitable(payload) {
    return Request.post("resume/ResumeAuthorized/reject", payload);
  }
  getResumeAuthor(payload) {
    return Request.post("head-post/job/getResumeAuthorizedList", payload);
  }
  // 职位画像匹配列表
  getAuthorizedJobDrawList(payload) {
    return Request.post("head-post/job/getAuthorizedJobDrawList", payload);
  }
  /**
   * 更新职位画像
   * @param { job_id } payload
   */
  updateJobDraw(payload) {
    return Request.post("/job/updateJobDraw", payload);
  }

  resumeDetails(payload) {
    return Request.post("/resume/detail", payload);
  }

  /**
   * 获取简历附件
   * @param {*} payload
   */
  getAttachedResume(payload) {
    return Request.post("resume/attachment/get-all", payload);
  }
  /**
   * 推荐简历
   * @param {*} payload
   */
  postResume(payload) {
    return Request.post("/post/create", payload);
  }
  /**
   * 用户标签
   * @param {*} payload
   */
  getUserTags(payload) {
    return Request.post("/resume/SoftSkillUserTag/get-all", payload);
  }
  /**
   * 软性点评列表
   */
  softSkill() {
    return Request.post("/resume/soft-skill/get-tree");
  }

  // 案情通告
  getNotice(payload) {
    return Request.post("/job/case-notice/get-list", payload);
  }

  /**
   * 职位动态
   * @param {*} payload
   */
  getFeed(payload) {
    return Request.post("/job/job-feed/get-list", payload);
  }

  //查看简历附件
  generatePreview(payload) {
    return Request.post("/resume/generatePreview", payload);
  }
}

export const position = new Position();
